/* eslint-disable @typescript-eslint/no-empty-function */
import Avatar from "components/core/Avatar";
import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import { palette } from "lib/miolo";
import Link from "next/link";

interface IBrazilianCompanySubsidiariesProps {
  subsidiaries: IBrazilianCompanyIssuerTopLevelFragment["subsidiaries"];
}

export default function BrazilianCompanySubsidiaries({ subsidiaries }: IBrazilianCompanySubsidiariesProps) {
  return (
    <div className="space-y-4">
      <div>
        <h4 className="font-aeonik text-base font-bold uppercase text-gray-600">Subsidiárias</h4>
        <p className="font-aeonik text-sm font-normal text-gray-500">
          Principais empresas com posições majoritárias, relevantes ou de controle.
        </p>
      </div>

      <div className="flex flex-col gap-4 space-y-1 xl:grid xl:grid-cols-4 xl:space-y-0">
        {subsidiaries.map((subsidiary) => {
          const linkAs = `/br/${subsidiary.tickerSymbolPrefix.toLowerCase()}`;
          const linkHref = "/br/[tickerSymbol]";

          return (
            <Link
              key={subsidiary.tickerSymbolPrefix}
              as={linkAs}
              href={linkHref}
              className="group relative flex w-full rounded-xl border border-slate-200 bg-slate-50 no-underline"
            >
              <div className="flex items-center space-x-4 p-3">
                <Avatar
                  src={subsidiary.niceLogo?.url || null}
                  hashValue={subsidiary._id}
                  alt={subsidiary.name}
                  size={40}
                  squircle={true}
                />

                <div className="truncate">
                  <h3 className="text-md truncate font-semibold text-gray-800 group-hover:underline">
                    {subsidiary.name}
                  </h3>
                  <span className="text-xs font-medium text-gray-500">{subsidiary.sector}</span>
                </div>
              </div>
              <div
                aria-hidden={true}
                className="absolute top-3 -left-0.5 h-[calc(100%-24px)] w-1 rounded-xl"
                style={{
                  backgroundColor: subsidiary.niceLogo?.dominantColor || palette.royalBlue,
                }}
              />
            </Link>
          );
        })}
      </div>
    </div>
  );
}
